export const uk = {
    'status-new': 'Новый',
    'status-no': 'Отклонён',
    'status-waiting': 'Ожидает подтверждения',
    'status-yes': 'Принятый'
};
